var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _setup.isLogo20 ? _c(_setup.Logo20Component) : _c(_setup.SLogo);
};
var staticRenderFns = [];
export { render, staticRenderFns };